import React, { Children } from "react";
import { useTranslation } from "react-i18next";

import { Select } from "@krea/customer-features/shared-components/fields/select/";
import { Helper } from "@krea/customer-features/shared-components/helper";

const LeasingObject = ({
  tooltip,
  value,
  error,
  onChange,
  objects,
  size,
  name,
  label,
}) => {
  const { t } = useTranslation();

  return (
    <Select
      name={name}
      size={size}
      id={name}
      label={
        <>
          <span className="align-middle mr-1">{label}</span>
          {tooltip && (
            <span className="align-top">
              <Helper content={tooltip} />
            </span>
          )}
        </>
      }
      value={value}
      error={error}
      onChange={onChange}
    >
      <option value="" disabled>
        {t("applicationForm.leasing.fields.objectType.placeholder")}
      </option>
      {Children.toArray(
        objects.map((item) => <option value={item.value}>{item.name}</option>),
      )}
    </Select>
  );
};

export default LeasingObject;
